import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { ConfigService, CoreSaveService, FieldType, ICommonMessage, MessageService } from '@gbs-platform-client/fwk-core';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PageHeader } from 'src/app/utils/models/page-header';
import{Adminportal} from '../../models/adminportal';
import{AdminportalService} from '../../services/adminportal.service';
import { AddUser } from '../../models/adduser';
import { AddUserService } from '../../services/adduser.service';
@Component({
  selector: 'app-admin-portal',
  templateUrl: './admin-portal.component.html',
  styleUrls: ['./admin-portal.component.css']
})
export class AdminPortalComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('approveaction') approveaction!: TemplateRef<any>;
  @ViewChild('reject') reject!: TemplateRef<any>;
  @ViewChild('Remarks') Remarks!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerAdminportal: PageHeader;
entity: AddUser = new AddUser();
editingEntity: Adminportal = new Adminportal();
selectedBloodgroup: Adminportal = new Adminportal();
Adminportal: any;
adduserColumns: Array<any> = [];
listView: boolean = true;
formCaption: string = '';
pageSkip: number = 0;
pageSizes: any = [];
selectedBranchcategory: Adminportal = new Adminportal();
adduser: Array<AddUser>;
//  user = JSON.parse(localStorage.getItem('currentUser') || '{}'); 
 constructor(
    private _adminportalService: AdminportalService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private configService: ConfigService,
    private notification: NotificationsService,
    private _adduserService: AddUserService,
    
  ) { 
    this.headerAdminportal = this.initPageHeader();
     const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    
    this.adduser=[];
    this.getAllAdduser();
   
   
  }
  ngAfterViewInit(): void {
    this.adduserColumns=[
      { field: "UserId", title: 'User Id', filter: true, sortable: true, width: 150  },
      { field: "UserName", title: 'User Name', filter: true, sortable: true, width: 150 },
      { field: "DisplayName", title: 'Display Name', filter: true, sortable: true, width: 150 },
      { field: "Role_Name", title: 'Role Name', filter: true, sortable: true, width: 150 },
      { field: "Emp_Name", title: 'Employee Name', filter: true, sortable: true, width: 150 },
      { field: "Entity_Name", title: 'Entity Name', filter: true, sortable: true, width: 150 },
      { field: "Email", title: 'Email Id', filter: true, sortable: true, width: 150 },
      { field: "PhoneNumber", title: 'Phone', filter: true, sortable: true, width: 150 },
      { field: "Remarks", title: 'Remarks', width: 250, template: this.Remarks, filter: true, sortable: true },
      { field: "", title: 'Approve', template: this.approveaction, width: 150 },
      { field: "", title: 'Reject', template: this.reject, width: 150 }   
    ]
  }
 
  initPageHeader(): PageHeader {
    let headerAdminportal = new PageHeader();
    headerAdminportal.PageCaption = "Admin Portal";
    headerAdminportal.IconClass = "bi bi-droplet-fill";
    return headerAdminportal;
  }

  approve(event: any) {
    var message: ICommonMessage = {
      eventName: "showDialog",
      param: {
        content: "Do you want to approve?",
        caption: "User Approval",
        returnKey: "Approve_confirmation"
      }
    };
    this.messageService.sendCommonMessage(message);
  }
  
  rejectaction(event: any) {
    var message: ICommonMessage = {
      eventName: "showDialog",
      param: {
        content: "Do you want to reject?",
        caption: "User Rejection",
        returnKey: "Approve_confirmation"
      }
    };
    this.messageService.sendCommonMessage(message);
  }
 
  getAllAdduser() {
    this._adduserService.getAllAdduser().subscribe((adduser: Array<AddUser>) => {
      this.adduser = adduser;
    });
  }
  // clearAdmin()
  // {
  //   this.entity=new Adminportal();
  //   this.saveDisabled=true;

  // }

 
  // getAllAdmin(){
  //   this._adminportalService.getAllAdmin('', Number(this.defaultPageSize),1,0).subscribe((admin: Array<Adminportal>) => {
  //     this.Adminportal = {
  //       data: admin,
  //       total:admin[0] ? admin[0].TotalCount : 0
  //     }
  //   });
  // }
 
 
 
 
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._adminportalService.deleteAdmin(this.selectedBranchcategory.Admin_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            // this.clearAdmin();
            this.getAllAdduser();
          },
          )
        }
      }
    });
  }

  gotoBack(): void {
    this.listView = true;
    this.getAllAdduser();
    // this.clearAdmin();
  }
  refreshAdmin(event: any): void {
   this.getAllAdduser();
  }
  onExcelExport() {
    this.excelexport.save()
  }
 
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  AlphabetsOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return true;
    }
    return false;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
